import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  const ms30 = {
    label: "Freeze Account Reason",
    pageLabel: "Freeze Account Reason",
    starting: true,
    url: "ms30",
    pageType: "history",
    form: [
      {
        inputType: "handsonTable",
        widths: {
          parent: "col-sm-12",
          children: "col-sm-12"
        },
        name: "freezeact",
        description: "none",
        tableOptions: {
          // validations, basic calculations, colors, date pickers, context menu etc.
          HOTheaders: ["Code", "Description.", "Active","Descn(Regional)"],
          columns: [{}, {}, {},{}],
          rowHeaders: false,
          // contextMenu: true,
          minSpareRows: 4,
          stretchH: "last",
          // columnSorting: true,
          autoWrapRow: true,
          maxRows: 100
        }
      }
    ]
  };
  export default ms30;